<template>
    <div class="wrap">
        <Header/>
        <router-view/>
        <Footer/>
    </div>
</template>
<script>
import Header from './header'
import Footer from './footer'
export default {
    name:'Layout',
    components:{
        Header,
        Footer
    }
}
</script>
<style scoped>
    .wrap {
        /* padding:0 7.6%; */
        /* min-height: 700px;
        height: 100%; */
        position: relative;
    }
</style>


// WEBPACK FOOTER //
// src/layout/index.vue